module.exports = __webpack_public_path__ + "media/images/front/sp_tl-menu_active-36d2784e4c15cc6909a83b6c50ca3cb6.png";